import {NgModule} from '@angular/core';
import {CB_ENTITY_PROVIDER} from "./cb.entity-provider";
import {CoreModule} from "../../core/core.module";
import {CbConfigPage} from "./page/cb-config-page/cb-config.page";
import {CbPlaygroundPage} from "./page/cb-playground-page/cb-playground.page";
import {CbQueryPlaygroundComponent} from "./component/cb-query-playground/cb-query-playground.component";
import {CbWorkbenchPage} from "./page/cb-workbench-page/cb-workbench.page";
import {CbWorkbenchComponent} from "./component/cb-workbench/cb-workbench.component";
import {
    CbSchemaCoverageCanvasComponent
} from "./component/cb-schema-coverage-canvas/cb-schema-coverage-canvas.component";
import {
    CbEntityDocumentationEditorComponent
} from "./component/cb-entity-documentation-editor/cb-entity-documentation-editor.component";
import {CbDomainConceptGraphComponent} from "./component/cb-domain-concept-graph/cb-domain-concept-graph.component";
import {CbConceptEditorComponent} from "./component/cb-concept-editor/cb-concept-editor.component";
import {
    CbQueryTemplateBuilderComponent
} from "./component/cb-query-template-builder/cb-query-template-builder.component";
import {CbBusinessRuleBuilderComponent} from "./component/cb-business-rule-builder/cb-business-rule-builder.component";
import {CbTrainingDashboardComponent} from "./component/cb-training-dashboard/cb-training-dashboard.component";
import {CbInfoPage} from "./page/cb-info-page/cb-info.page";
import {CbSchemaCoverageComponent} from "./component/cb-schema-coverage/cb-schema-coverage.component";
import {CbCoverageModuleTableComponent} from "./component/cb-coverage-module-table/cb-coverage-module-table.component";
import {CbCoverageEntityTableComponent} from "./component/cb-coverage-entity-table/cb-coverage-entity-table.component";
import {CbCoverageCanvasViewComponent} from "./component/cb-coverage-canvas-view/cb-coverage-canvas-view.component";

import {
    CbCoverageEntityDetailComponent
} from "./component/cb-coverage-entity-detail/cb-coverage-entity-detail.component";
import {CbTenantSyncPanelComponent} from "./component/cb-tenant-sync-panel/cb-tenant-sync-panel.component";
import {CbRecordDocumentationComponent} from "./component/cb-record-documentation/cb-record-documentation.component";
import {CbDevPlaygroundPage} from "./page/cb-dev-playground-page/cb-dev-playground.page";
import {CbToolExplorerComponent} from "./component/cb-tool-explorer/cb-tool-explorer.component";
import {CbToolExecutorComponent} from "./component/cb-tool-executor/cb-tool-executor.component";
import {CbDebugPanelComponent} from "./component/cb-debug-panel/cb-debug-panel.component";
import {CbWorkflowExplorerComponent} from "./component/cb-workflow-explorer/cb-workflow-explorer.component";
import {CbWorkflowExecutorComponent} from "./component/cb-workflow-executor/cb-workflow-executor.component";
import {CbExecutionTimelineComponent} from "./component/cb-execution-timeline/cb-execution-timeline.component";
import {CbExecutionHistoryComponent} from "./component/cb-execution-history/cb-execution-history.component";
import {CbFinderRoundViewerComponent} from "./component/cb-finder-round-viewer/cb-finder-round-viewer.component";
import {CbFinderResultViewerComponent} from "./component/cb-finder-result-viewer/cb-finder-result-viewer.component";


@NgModule({
    declarations: [
        CbInfoPage,
        CbConfigPage,
        CbPlaygroundPage,
        CbQueryPlaygroundComponent,
        CbWorkbenchPage,
        CbWorkbenchComponent,
        CbSchemaCoverageCanvasComponent,
        CbEntityDocumentationEditorComponent,
        CbDomainConceptGraphComponent,
        CbConceptEditorComponent,
        CbQueryTemplateBuilderComponent,
        CbBusinessRuleBuilderComponent,
        CbTrainingDashboardComponent,
        CbSchemaCoverageComponent,
        CbCoverageModuleTableComponent,
        CbCoverageEntityTableComponent,
        CbCoverageCanvasViewComponent,
        CbCoverageEntityDetailComponent,
        CbTenantSyncPanelComponent,
        CbRecordDocumentationComponent,
        CbDevPlaygroundPage,
        CbToolExplorerComponent,
        CbToolExecutorComponent,
        CbDebugPanelComponent,
        CbWorkflowExplorerComponent,
        CbWorkflowExecutorComponent,
        CbExecutionTimelineComponent,
        CbExecutionHistoryComponent,
        CbFinderRoundViewerComponent,
        CbFinderResultViewerComponent,
    ],
    exports: [
        CbInfoPage,
        CbConfigPage,
        CbPlaygroundPage,
        CbQueryPlaygroundComponent,
        CbWorkbenchPage,
        CbWorkbenchComponent,
        CbSchemaCoverageCanvasComponent,
        CbEntityDocumentationEditorComponent,
        CbDomainConceptGraphComponent,
        CbConceptEditorComponent,
        CbQueryTemplateBuilderComponent,
        CbBusinessRuleBuilderComponent,
        CbTrainingDashboardComponent,
        CbSchemaCoverageComponent,
        CbCoverageModuleTableComponent,
        CbCoverageEntityTableComponent,
        CbCoverageCanvasViewComponent,
        CbCoverageEntityDetailComponent,
        CbTenantSyncPanelComponent,
        CbRecordDocumentationComponent,
        CbDevPlaygroundPage,
        CbToolExplorerComponent,
        CbToolExecutorComponent,
        CbDebugPanelComponent,
        CbWorkflowExplorerComponent,
        CbWorkflowExecutorComponent,
        CbExecutionTimelineComponent,
        CbExecutionHistoryComponent,
        CbFinderRoundViewerComponent,
        CbFinderResultViewerComponent,
    ],
    imports: [
        CoreModule,
    ],
    providers: [CB_ENTITY_PROVIDER]
})
export class CbModule {
}
